<template>
  <div class="acc-setting profile-series-h tw-shadow-xl tw-rounded-sm">
    <h3 class="tw-px-8 tw-py-8 tw-font-bold tw-text-primary tw-relative tw-border-b tw-border-light-3 tw-flex tw-items-center tw-justify-between">
      <div class="tw-font-bold tw-text-dark">{{title}}</div>
      <div>
        <slot name="actions"></slot>
      </div>
    </h3>
    <slot></slot>
  </div>
</template>
<script>
  export default {
    props: {
      title: {},
    }
  }
</script>
